// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  firebaseConfig : {
    apiKey: "AIzaSyC37cMjGWr1q5d8rm7DVbfDhKP_w0fgt10",
    authDomain: "bigmart-online.firebaseapp.com",
    databaseURL: "https://bigmart-online.firebaseio.com",
    projectId: "bigmart-online",
    storageBucket: "bigmart-online.appspot.com",
    messagingSenderId: "47369179063",
    appId: "1:47369179063:web:259af70f6c99282cd42232",
    measurementId: "G-VJC9FQRK9V"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
